<template>
  <div
    v-if="$store.state.isSignIn"
    class="base">
    <Header
      @setView="setView"
      @showForm="showForm" />
    <Menu
      v-if="$store.state.existsGroup"
      v-show="$store.state.isShowMenu" />
    <Form
      v-if="isShowForm"
      :propsUserId="userId"
      :propsThisDate="date"
      @close="isShowForm = false" />
    <div
      v-if="$store.state.selectedUsers.length > 0 && !($store.state.users.error || $store.state.groups.error || $store.state.diaries.error)"
      class="main-content">
      <router-view
        v-if="!$store.state.isLoading"
        @setView="setView"
        @showForm="showForm" />
      <img
        v-else
        id="loading"
        src="@/assets/img/loading.svg"
        width="64"
        height="64">
    </div>
    <div
      v-else
      class="announce">
      <span v-if="$store.state.users.error">ユーザーの取得に失敗しました<br>通信環境を確認の上、画面を再読み込みをしてください</span>
      <span v-else-if="$store.state.groups.error ">グループの取得に失敗しました<br>通信環境を確認の上、画面を再読み込みをしてください</span>
      <span v-else-if="$store.state.diaries.error">日報の取得に失敗しました<br>通信環境を確認の上、画面を再読み込みをしてください</span>
      <span v-else-if="!$store.state.existsGroup">読み込み中...</span>
      <span v-else-if="!$store.state.existsRelation">メンバーの取得に失敗しました<br>通信環境を確認の上、画面を再読み込みをしてください<br>再読み込みで改善しない場合メンバーが設定されていない可能性があります。その場合は管理者に問い合わせてください</span>
      <span v-else-if="$store.state.isNoUsersInSelectedGroup">ユーザーがいません</span>
      <span v-else>
        <span v-if="!$store.state.isShowMenu">左上の<span class="material-icons">menu</span>からグループ選択エリアを開き<br></span>
        画面左部のエリアから表示するグループを選択してください
      </span>
    </div>
  </div>
</template>

<script>
import Moment from 'moment'
import sw from '@/utils/sweetAlert'
import Header from '@/components/modules/DailyReport/Header'
import Menu from '@/components/modules/DailyReport/Menu'
import Form from '@/components/modules/DailyReport/Form'

export default {
  components: {
    Header,
    Menu,
    Form
  },
  data () {
    return {
      /**
       * 入力フォーム出現フラグ
       * @type {Boolean}
       */
      isShowForm: false,
      /**
       * 入力フォームに送るユーザーID
       * @type {String}
       */
      userId: '',
      /**
       * 入力フォームに送る日付
       * @type {Moment}
       */
      date: ''
    }
  },
  async beforeCreate () {
    this.$store.commit('setIsLoading', true)
    try {
      await this.$store.dispatch('initializeUser')
      await this.$store.dispatch('getGroups')
      if (this.$store.state.existsGroup) return
      await this.$store.dispatch('getUsers')
      this.$store.dispatch('getDiaries')
    }
    catch (error) {
      console.error(error)
    }
  },
  methods: {
    /**
     * userIdとdateで日報を検索し、
     * 本人の日報なら編集モード、それ以外なら参照モードでフォームを表示する
     * @param {String} userId firestoreから取得したuserId
     * @param {String} date 選択したマスに格納されていた日時
     */
    showForm (userId, date) {
      try {
        if (this.$store.state.currentUser.id !== userId && !this.$store.state.diaries.data[userId][date]) {
          sw.toastAlert('error', '日報が投稿されていない為、参照できません')
          return
        }
        if (Moment(date).isAfter(this.$store.state.today, 'day')) {
          sw.toastAlert('error', '未来の日報は入力・参照出来ません')
          return
        }
        if (this.$store.state.currentUser.id === userId && !this.$store.state.users.data.find(u => u.id === userId)) {
          this.$store.commit('addUsers', [this.$store.state.currentUser])
        }
        this.userId = userId
        this.date = Moment(date)
        this.isShowForm = true
      } catch (e) {
        sw.toastAlert('error', 'ユーザーまたは日付が正しく選択されていません')
      }
    },
    /**
     * 月、日、人表示を切り替える
     * @param {String} path 切り替え先のパス
     * @param {Moment} date 日画面で表示する1日の日付
     * @param {String} user 人画面で表示するユーザーのID
     */
    setView (path, date, user) {
      // パスと今いるビューのパスが同じなら終了
      if (this.$route.path === path) {
        return
      }
      switch (path) {
        case '/month': {
          this.$store.commit('setThisDate', date)
          this.$router.push(path)
          break
        }
        case '/day': {
          if (!this.$store.state.thisDate.isSame(date, 'month')) {
            date = Moment(this.$store.state.thisDate).startOf('month')
          }
          this.$store.commit('setThisDate', Moment(date))
          this.$router.push(path)
          break
        }
        case '/user': {
          this.$store.commit('setSelectedUserId', user)
          this.$router.push(path)
          break
        }
      }
    }
  }
}
</script>

<style scoped>
.base {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  user-select: none;
  background: #fff;
}
.main-content {
  position: relative;
  width: auto;
  height: 100%;
  overflow: hidden;
}
.announce {
  width: auto;
  height: 100%;
  font-size: 12px;
  background: #f6f8f7;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #828282;
  overflow: none;
}
.announce .material-icons {
  color: #828282;
  display: inline-flex;
  vertical-align: middle;
}
#loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/DailyReport.vue